<template>
  <button-link class="mt-200 mb-100" @click="goToIntegrationsTab">Back to Integrations</button-link>
</template>

<script>
export default {
  name: "IntegrationBackButton",
  methods: {
    goToIntegrationsTab() {
      this.$router.push({name: "settings", params: {'tab': 'integrations'}})
    }
  },
}
</script>

<style scoped>

</style>
